"use strict";

function OpenFinWebAuthenticator(
  $log,
  $q,
  authTokenProvider,
  rediTokenService,
  OpenfinWindowFactory,
  cookieRepository,
  cookieService,
  openFinApi
) {
  var that = this;
  var isAuthenticatedDeferred;

  that.authenticate = function(params) {
    if (!isAuthenticatedDeferred) {
      isAuthenticatedDeferred = $q.defer();
      if (authTokenProvider.get() !== null) {
        isAuthenticatedDeferred.resolve();
      } else {
        getAndCacheAuthToken(params);
      }
    }
    return isAuthenticatedDeferred.promise;
  };

  function getAndCacheAuthToken(params) {
    return getAuthToken(params).then(
      function(authToken) {
        $log.debug("Authenticated");
        rediTokenService.storeAuthTokenFrom(authToken);
        isAuthenticatedDeferred.resolve();
      },
      function(response) {
        $log.error("Failed to authenticate: " + JSON.stringify(response));
        isAuthenticatedDeferred.reject(new Error("Failed to authenticate"));
      }
    );
  }

  function getAuthToken(params) {
    if (params.token) {
      return rediTokenService.postAuthByPasswordServerToken(
        params.token,
        params.username,
        params.timestamp
      );
    } else {
      return cookieRepository
        .getRtDevice()
        .then(function(rtDevice) {
          return getAuthTokenOrMfaResponse(params, rtDevice);
        })
        .then(function(response) {
          return handleMfa(response, params);
        });
    }
  }

  function getAuthTokenOrMfaResponse(params, rtDevice) {
    if (rtDevice) {
      return rediTokenService.postAuthByUsernameAndRtDevice(
        params.username,
        params.password,
        rtDevice
      );
    } else {
      return rediTokenService.postAuthByUsername(
        params.username,
        params.password
      );
    }
  }

  function handleMfa(response, params) {
    if (response.rtUserMfaPrompt) {
      cookieRepository.setRtDeviceCookies(response.mfaCookies);
      openFinApi.publish("mfa-required");
      return cookieService
        .setCookiesOnUrl(response.baseRedirectURL, response.mfaCookies)
        .then(function() {
          return promptMfa(response, params);
        });
    }
    return response;
  }

  function promptMfa(response, params) {
    var url = getMfaUrl(response);
    return OpenfinWindowFactory.createSimpleOpenfinWindow(url, "mfa-window")
      .then(function() {
        return $q(function(resolve, reject) {
          openFinApi.subscribe(
            "*",
            "mfa-successful",
            function onMfaSuccess() {
              openFinApi.unsubscribe("*", "mfa-successful", onMfaSuccess);
              resolve();
            },
            undefined,
            reject
          );
        });
      })
      .then(function() {
        return getAuthTokenOrMfaResponse(params, response.rtDevice);
      });
  }

  function getMfaUrl(mfaResponse) {
    return (
      mfaResponse.baseRedirectURL +
      "/redi/openfin/routes/mfa.html?epaid=" +
      mfaResponse.epaid
    );
  }
}

module.exports = /* @ngInject */ OpenFinWebAuthenticator;



// WEBPACK FOOTER //
// ./app/business/openFinWebAuthenticator.js